import { useCallback } from "react";
import useOauth from "@utils/customHooks/useOauth";

// Manual authenticated download (the generated download query hook is not
// suited to on-demand binary fetch). Mirrors DocumentTemplates Edit.
export const useDownloadAttachment = () => {
  const [accessToken] = useOauth();

  // useCallback so the returned function is stable across renders (safe to use
  // in effect deps and to pass down as a prop).
  return useCallback(
    async (id: string, filename: string): Promise<void> => {
      const host = process.env.REACT_APP_SCOPESTACK_API_HOST;
      const response = await fetch(
        `${host}/v2/project-attachments/${id}/download`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "download";
      // Append to the document so the browser reliably honors the click before
      // we revoke the object URL (a synchronous revoke after click() races the
      // browser's async fetch of the blob and can yield a 0-byte file).
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => window.URL.revokeObjectURL(url), 10_000);
    },
    [accessToken]
  );
};

export default useDownloadAttachment;
